module.exports = __webpack_public_path__ + "img/subscription-outline.c945f55d.png";